import script from "./SplashView.vue?vue&type=script&setup=true&lang=js"
export * from "./SplashView.vue?vue&type=script&setup=true&lang=js"

import "./SplashView.vue?vue&type=style&index=0&id=2a0ed394&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a0ed394"]])

export default __exports__